'use client'

import { ChevronRight } from 'lucide-react'
import { Reveal } from '../hooks/useReveal'

const services = ['/ AI AUTOMATION', '/ AI INTEGRATION', '/ AI AGENT DEVELOPMENT']

const PORTRAIT_URL =
  'https://images.higgs.ai/?default=1&output=webp&url=https%3A%2F%2Fd8j0ntlcm91z4.cloudfront.net%2Fuser_38xzZboKViGWJOttwIXH07lWA1P%2Fhf_20260728_050334_5b076e26-0ce7-4898-b432-d764190e448f.png&w=1280&q=85'

export function Hero() {
  return (
    <section
      className="relative min-h-screen min-h-[100svh] flex flex-col justify-between"
      style={{ paddingTop: '6rem', paddingBottom: '3rem' }}
    >
      <div className="px-5 sm:px-8 md:px-12 w-full">
        {/* Top row: services left, intro right */}
        <div className="flex flex-col sm:flex-row justify-between gap-8 mb-12 sm:mb-0">
          {/* Services list */}
          <div className="flex flex-col gap-2">
            {services.map((service, i) => (
              <Reveal key={service} delay={150 + i * 120} className="font-mono text-xs uppercase tracking-[0.15em] text-white/90 drop-shadow-md">
                {service}
              </Reveal>
            ))}
          </div>

          {/* Intro text */}
          <Reveal delay={300} className="max-w-xs sm:text-right">
            <p className="text-lg sm:text-xl leading-relaxed text-white drop-shadow-md">
              We design automation that brings clarity, precision, and efficiency to the way your company operates.
            </p>
          </Reveal>
        </div>

        {/* Bottom row: badge + H1 left, glass card right */}
        <div className="flex flex-col md:flex-row items-end justify-between gap-8 mt-16">
          {/* Left: badge + H1 */}
          <div className="w-full md:max-w-2xl">
            <Reveal delay={150} className="mb-5">
              <span className="border-l-2 border-white bg-white/15 px-3 py-1.5 backdrop-blur-md font-mono text-[11px] uppercase tracking-[0.15em] inline-block">
                We Automate 100+ Businesses
              </span>
            </Reveal>

            <Reveal delay={280}>
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-normal leading-[1.05] tracking-tight text-white drop-shadow-lg">
                Clear. Precise.<br />
                Automated.
              </h1>
            </Reveal>
          </div>

          {/* Right: glass contact card */}
          <Reveal delay={420}>
            <div className="flex items-center gap-4 rounded-xl bg-white/15 p-3 backdrop-blur-md w-full md:w-auto">
              <img
                src={PORTRAIT_URL}
                alt="Mitha, co-founder of NovaAI"
                className="h-24 w-20 rounded-lg object-cover flex-shrink-0"
              />
              <div className="flex flex-col gap-1.5 pr-2">
                <span className="text-sm font-medium text-white">Talk with Mitha</span>
                <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-white/60">
                  Co-founder of NovaAI
                </span>
                <button className="rounded-full bg-white px-4 py-2 text-xs font-medium text-black hover:bg-white/85 transition-colors duration-300 mt-1.5 w-fit flex items-center gap-1.5">
                  Book 15-mins call
                  <ChevronRight className="w-3.5 h-3.5" />
                </button>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  )
}